import Arrays from "utils/Arrays";
import CommentTargetTypes from "const/CommentTargetTypes";
import CommentsActions from "actions/CommentsActions";
import TasksActions from "actions/TasksActions";

const {
  FETCH_TASKS_LIST_START,
  FETCH_TASKS_LIST_DONE,
  FETCH_TASKS_LIST_ERROR,
  FETCH_TASK_START,
  FETCH_TASK_DONE,
  FETCH_TASK_ERROR,
  ADD_NEW_TASK_START,
  ADD_NEW_TASK_DONE,
  ADD_NEW_TASK_ERROR,
  EDIT_TASK_START,
  EDIT_TASK_DONE,
  EDIT_TASK_ERROR,
  BULK_EDIT_TASKS_START,
  BULK_EDIT_TASKS_DONE,
  BULK_EDIT_TASKS_ERROR,
  DELETE_TASK_START,
  DELETE_TASK_DONE,
  DELETE_TASK_ERROR,
  CLEAR_TASKS,
  SET_TASKS_READY_TO_DISPLAY
} = TasksActions;

const { ADD_NEW_COMMENT_START, MARK_ALL_AS_READ_DONE } = CommentsActions;

const initialState = {
  fetchingData: false,
  tasksReadyToDisplay: false,
  dataHash: null,
  data: [],
  active: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case FETCH_TASKS_LIST_START:
      return {
        ...state,
        ...(payload.clearList ? { data: [], dataHash: null } : {}),
        fetchingData: !payload.backgroundUpdate
      };

    case FETCH_TASK_START:
    case ADD_NEW_TASK_START:
      return { ...state, fetchingData: true };

    case DELETE_TASK_START:
      return { ...state, fetchingData: true, data: state.data.filter(({ id }) => id !== payload.taskId) };

    case EDIT_TASK_START:
      return {
        ...state,
        fetchingData: true,
        data: payload?.task ? state.data.map((task) => {
          if (task.id === payload.task.id) return { ...task, ...payload.task };

          return task;
        }) : state.data
      };

    case BULK_EDIT_TASKS_START:
      return { ...state, fetchingData: !payload.backgroundUpdate };

    case ADD_NEW_COMMENT_START: {
      const { targetType, targetId } = payload;

      if (targetType !== CommentTargetTypes.TASKS) return state;

      return {
        ...state,
        data: Arrays.updateItemById(state.data, targetId, (task) => {
          return { ...task, comments: { ...task.comments, all: task.comments.all + 1 } };
        })
      };
    }

    case FETCH_TASKS_LIST_DONE: {
      const newData = payload.dataHash === state.dataHash
        ? state.data
        : (payload.editableTaskId
          ? payload.tasks.map((task) => {
            if (task.id === payload.editableTaskId) {
              return {
                ...state.data.find(({ id }) => id === task.id),
                ...task
              };
            }

            return task;
          })
          : payload.tasks);

      return { ...state, fetchingData: false, data: newData, dataHash: payload.dataHash };
    }

    case ADD_NEW_TASK_DONE:
      return { ...state, fetchingData: false };

    case FETCH_TASK_DONE:
    case EDIT_TASK_DONE: {
      return {
        ...state,
        fetchingData: false,
        data: state.data.map((task) => {
          if (task.id === payload.task.id) return { ...task, ...payload.task };

          return task;
        })
      };
    }

    case BULK_EDIT_TASKS_DONE: {
      const { tasks } = payload;

      return {
        ...state,
        fetchingData: false,
        data: state.data.map((task) => tasks.find(({ id }) => id === task.id) || task)
      };
    }

    case DELETE_TASK_DONE:
      return { ...state, fetchingData: false };

    case FETCH_TASKS_LIST_ERROR:
    case FETCH_TASK_ERROR:
    case ADD_NEW_TASK_ERROR:
    case EDIT_TASK_ERROR:
    case DELETE_TASK_ERROR:
    case BULK_EDIT_TASKS_ERROR:
      return { ...state, fetchingData: false };

    case MARK_ALL_AS_READ_DONE:
      return {
        ...state,
        data: state.data.map((item) => ({
          ...item,
          comments: item.comments && { ...item.comments, unread: 0 }
        }))
      };

    case CLEAR_TASKS:
      return {
        fetchingData: false,
        dataHash: null,
        data: []
      };

    case SET_TASKS_READY_TO_DISPLAY:
      return { ...state, tasksReadyToDisplay: payload };

    default:
      return state;
  }
};
